import { createFileRoute } from '@tanstack/react-router'
import { CustomerEditPage } from '@/features/operations/pages/customer-edit-page'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/customers/$id')({
  beforeLoad: requireRole(['admin']),
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <CustomerEditPage customerId={id} />
}
